import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/fileManager`;
const baseServiceUrlWebUpload = `/api/v1/filesservicecontroler`;

const env = process.env;

const ApiFilesService = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getFileType: () => {
    const url = `${baseServiceUrl}/GetFileType`;
    console.log("url==========", url);
    return ServiceApi.get(url);
  },
  saveFileInfo: (params) => {
    const url = `${baseServiceUrl}/saveFileInfo`;
    const data = { data: params };
    console.log("params==========2222", { params }, params);
    //,{baseURL:env.REACT_APP_PHOTOPATH_WEB }
    return ServiceApi.post(url, params);
  },
  uploadFiles: (params) => {
    const url = `${baseServiceUrlWebUpload}/uploadFiles`;
    const data = { data: params };
    console.log("params==========2222", { params }, params);
    //,{baseURL:env.REACT_APP_PHOTOPATH_WEB }
    return ServiceApi.post(url, params, {
      baseURL: env.REACT_APP_PHOTOPATH_WEB,
    });
  },
  getBasketItemFile: (params) => {
    console.log("parapapapapapapa ", params);
    const url = `${baseServiceUrl}/getItemFilesByDifferentId`;
    return ServiceApi.get(url, { params });
  },
  getFile: (params) => {
    // console.log("params==========",params);
    const url = `${baseServiceUrlWebUpload}/getFile`;
    console.log("url==========", url);
    return ServiceApi.get(url, {
      params: params,
      baseURL: env.REACT_APP_PHOTOPATH_WEB,
      responseType: "blob",
    });
  },
  changeActived: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/changeActived`;
    console.log("url==========", url);
    return ServiceApi.put(url, params);
  },
  changeVoucherFileStatus: (params) => {
    console.log("params==========", params);
    const url = `${baseServiceUrl}/changeVoucherFileStatus`;
    console.log("url==========", url);
    return ServiceApi.put(url, params);
  },
};

export default ApiFilesService;
